import { render, staticRenderFns } from "./retailWebOrderList.vue?vue&type=template&id=13b9b875&scoped=true"
import script from "./retailWebOrderList.vue?vue&type=script&lang=js"
export * from "./retailWebOrderList.vue?vue&type=script&lang=js"
import style0 from "./retailWebOrderList.vue?vue&type=style&index=0&id=13b9b875&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9b875",
  null
  
)

export default component.exports